import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Shield, ScrollText } from "lucide-react";
import { LegalText } from "@/components/LegalText";

export default function PublicGefaengnisordnung() {
  const [text, setText] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/gefaengnisordnung")
      .then((r) => {
        setText(r.data.text || "");
        setUpdatedAt(r.data.updated_at || "");
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-background text-zinc-200">
      <header className="border-b border-zinc-800 bg-[#0C0E12]">
        <div className="max-w-3xl mx-auto px-6 py-6 flex items-center gap-3">
          <div className="h-11 w-11 grid place-items-center bg-primary/20 border border-primary/40 rounded-sm">
            <Shield className="h-6 w-6 text-primary" />
          </div>
          <div>
            <div className="font-heading font-black text-xl tracking-tight text-white">SADCR</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400">Dept. of Corrections &amp; Rehabilitation</div>
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10">
        <div className="flex items-center gap-3 mb-6">
          <ScrollText className="h-6 w-6 text-primary" />
          <h1 className="font-heading text-3xl font-black uppercase tracking-tight text-zinc-100">Gefängnisordnung</h1>
        </div>
        {loading ? (
          <div className="text-zinc-500 font-mono text-sm">Wird geladen…</div>
        ) : text ? (
          <div data-testid="public-geford-content"><LegalText text={text} /></div>
        ) : (
          <div className="text-zinc-500 font-mono text-sm">Derzeit ist keine Gefängnisordnung veröffentlicht.</div>
        )}
        {updatedAt && (
          <div className="mt-10 pt-4 border-t border-zinc-800 font-mono text-[10px] uppercase tracking-[0.12em] text-zinc-600">
            Stand: {new Date(updatedAt).toLocaleString("de-DE")}
          </div>
        )}
      </main>
    </div>
  );
}
